<template>
  <div>
    <template v-if="auxComponent && auxComponentExists && queryGroupId">
      <TemplateQuerySet
        v-slot="{ data, status }"
        :query-set-group-id="queryGroupId"
        :filters="props.filters"
        :context="queryContext"
      >
        <template v-if="status === 'loading'">
          <ui-loader />
        </template>
        <template v-else-if="status === 'error'">
          Error loading data.
        </template>
        <template v-else>
          <component
            :is="auxComponent"
            v-model:value="value"
            v-model:form="form"
            :data="data"
          ></component>
        </template>
      </TemplateQuerySet>
    </template>
    <template v-else>
      {{ value }}
    </template>
  </div>
</template>

<script setup lang="ts">
import { TemplateQuerySet } from "#components";
import { panelQueryContext } from "~/scad-shared/utils/panelQueryContext";

const props = withDefaults(
  defineProps<{
    auxInputType?: string;
    filters?: Indexable;
    groupId?: string;
  }>(),
  {}
);

const queryGroupId = computed(() => props.groupId ? parseInt(props.groupId) : null);

const value = defineModel<any>("value");
const form = defineModel<any>("form", {
  default: () => ({}),
});

const queryContext = computed(() =>
  panelQueryContext(props.auxInputType, form.value),
);

const { get: auxComponent, exists: auxComponentExists } = useAuxInput(
  props.auxInputType ?? "",
  "infoPanel"
);
</script>

<style scoped></style>
